// components/home/Features/index.jsx
import React from 'react';
import { Camera, Clock, Heart, Shield, Star, Smile } from 'lucide-react';
import {
  FeaturesWrapper,
  FeaturesContainer,
  SectionHeader,
  FeaturesGrid,
  FeatureCard,
  IconWrapper,
  FeatureTitle,
  FeatureDescription
} from './styles';

const features = [
  {
    icon: <Camera size={24} />,
    title: 'Professional Quality',
    description: 'High-end equipment and experienced photographers ensure the best quality photos of your little ones.'
  },
  {
    icon: <Heart size={24} />,
    title: 'Baby-Friendly Environment',
    description: 'Comfortable and safe studio setting designed specifically for babies and young children.'
  },
  {
    icon: <Clock size={24} />,
    title: 'Flexible Scheduling',
    description: 'Easy booking system with weekend and evening slots available to suit your schedule.'
  },
  {
    icon: <Shield size={24} />,
    title: 'Safe & Secure',
    description: 'Your baby\'s safety is our top priority, with strict health and safety protocols in place.'
  },
  {
    icon: <Star size={24} />,
    title: 'Premium Experience',
    description: 'Personalized service and attention to detail for a memorable photography experience.'
  },
  {
    icon: <Smile size={24} />,
    title: 'Happy Memories',
    description: 'Capture beautiful milestones and create lasting memories of your baby\'s growth journey.'
  }
];

const Features = () => {
  return (
    <FeaturesWrapper>
      <FeaturesContainer>
        <SectionHeader
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2>Why Choose Le Petit?</h2>
          <p>Discover what makes our photography service special and perfect for your family</p>
        </SectionHeader>

        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <IconWrapper>
                {feature.icon}
              </IconWrapper>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeaturesGrid>
      </FeaturesContainer>
    </FeaturesWrapper>
  );
};

export default Features;